import React from "react"
import { withAssetPrefix } from "gatsby"
import tw, { css, styled } from "twin.macro"

export interface HeaderVideoProps {
  overlay?: boolean
  hide: boolean
}

const HeaderVideo: React.FC<HeaderVideoProps> = ({ overlay, hide }) => {
  if (hide == true) {
    return null
  }
  return (
    <Wrapper>
      <video
        autoPlay
        loop={false}
        playsInline
        muted
        src={withAssetPrefix("/video/video_small.mp4")}
        css={[tw`transition-opacity duration-500 absolute top-0 w-full h-full`, css`background-size: cover; overflow: hidden; min-width: 100%; min-height: 100%; width:auto; height:auto; object-fit: cover;
        `, overlay && css`opacity: 0.2`]}
      />
    </Wrapper>
)
};

const Wrapper = styled.div`
  z-index: -1;
  ${tw`fixed top-0 hidden md:visible h-full w-full flex flex-col justify-center text-center`}
`

export default HeaderVideo
